import React from "react";
import CustomTable from "../../components/CustomTable";
import { getCountries } from "../../../services/CommonServices";
import { countryValidationSchema } from "../../../utils/validationSchemas/MasterDataSchema";
import AddUpdateCountry from "./AddUpdate";

const Country = () => {
  const columns = [
    {
      label: "#",
      render: (row, index, currentPage, pageSize) => (
        <span>{(currentPage - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      label: "Name",
      key: "name",
    },
    {
      label: "Phone Code",
      key: "phonecode",
    },
    {
      label: "Code",
      key: "code",
    },
  ];
  const modalConfig = {
    initialValues: {
      name: "",
      phonecode: "",
      code: "",
    },
    validationSchema: countryValidationSchema,
    apiUrl: "master/countries",
    FormComponent: AddUpdateCountry,
    addTitle: "Add Country",
    updateTitle: "Update Country",
    extraProps: {},
  };
  return (
    <CustomTable
      title="Countries"
      addBtnTitle="Add New Country"
      columns={columns}
      getHook={getCountries}
      store={"country"}
      deleteHook={"master/countries"}
      formModal={true}
      modalConfig={modalConfig}
      search={true}
    />
  );
};

export default Country;
